import React, { memo, useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import CustomFilterModalDisplay from './CustomFilterModalDisplay';

export default memo(CustomFilterModal);

function CustomFilterModal(props) {
  const [state, updateState] = useState(() => ({
    endDate: props.customEndTimestamp
      ? new Date(props.customEndTimestamp)
      : null,
    maxDatapoints: props.maxDatapoints,
    startDate: props.customStartTimestamp
      ? new Date(props.customStartTimestamp)
      : null,
  }));

  const handleChangeEnd = useCallback((endDate) => {
      updateState((prevState) => ({ ...prevState, endDate }));
    }, []),
    handleChangeMaxDatapoints = useCallback(
      ({ target: { value } }) => {
        const maxDatapoints =
          value > props.globalMaxDatapoints
            ? props.globalMaxDatapoints
            : value < 0
              ? 0
              : value;
        updateState((prevState) => ({ ...prevState, maxDatapoints }));
      },
      [props.globalMaxDatapoints]
    ),
    handleChangeStart = useCallback((startDate) => {
      updateState((prevState) => ({ ...prevState, startDate }));
    }, []),
    handleSave = () => {
      props.handleCustomFilterSave({
        endDate: state.endDate,
        maxDatapoints: state.maxDatapoints,
        startDate: state.startDate,
      });
    };

  return (
    <CustomFilterModalDisplay
      {...props}
      {...state}
      handleChangeEnd={handleChangeEnd}
      handleChangeMaxDatapoints={handleChangeMaxDatapoints}
      handleChangeStart={handleChangeStart}
      handleSave={handleSave}
    />
  );
}

CustomFilterModal.propTypes = {
  customEndTimestamp: PropTypes.number,
  customStartTimestamp: PropTypes.number,
  globalMaxDatapoints: PropTypes.number,
  handleCustomFilterSave: PropTypes.func,
  isTextTile: PropTypes.bool,
  maxDatapoints: PropTypes.number,
  toggleModal: PropTypes.func,
};
